<template>
    <v-container class="grey-lighten-3 full-height">

        <!-- Printable Area -->
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

                    <!-- Watermark -->
                    <div class="watermark">
                        <img v-if="invoiceData?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + invoiceData?.branch?.company?.watermark" alt="">
                    </div>

                    <div class="invoice-container">
                        <div class="invoice-content">
                            <table style="width: 100%; border-collapse: collapse;">
                                <thead>
                                    <tr v-if="invoiceData?.branch?.company?.header_image && invoiceHeader">
                                        <td colspan="100%">
                                            <img :src="`${getFileServerUrl}${invoiceData?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- Header Section -->
                                    <tr v-if="!invoiceData?.branch?.company?.header_image && invoiceHeader">
                                        <td colspan="100%">
                                            <div class="page-header">
                                                <div class="header-section d-flex justify-space-between align-start">
                                                    <div class="company-info">
                                                        <h4 class="company-name">{{ invoiceData?.branch?.company?.name || 'Company Name Not Available' }}</h4>
                                                        <p class="company-text">{{ invoiceData?.branch?.company?.address || '-' }}</p>
                                                        <p class="company-text">
                                                            <v-icon size="small">mdi-phone-outline</v-icon>
                                                            {{ invoiceData?.branch?.company?.mobile || '-' }}
                                                        </p>
                                                        <p class="company-text">
                                                            <v-icon size="small">mdi-email-outline</v-icon>
                                                            {{ invoiceData?.branch?.company?.email || '-' }}
                                                        </p>
                                                        <p class="company-text" v-if="invoiceData?.branch?.company?.website">
                                                            <v-icon size="small">mdi-web</v-icon>
                                                            {{ invoiceData?.branch?.company?.website }}
                                                        </p>
                                                    </div>

                                                    <div class="logo-container">
                                                        <v-img
                                                            :src="`${getFileServerUrl.replace(/\/$/, '')}/${invoiceData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                                                            max-width="150"
                                                            max-height="70"
                                                            contain
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Title -->
                                    <tr>
                                        <td colspan="100%">
                                            <div class="text-center">
                                                <h2 class="report-title">PURCHASE INVOICE</h2>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Main Content -->
                                    <tr>
                                        <td colspan="100%" class="page-content-cell details-table">
                                            <div class="page-content" style="font-size: 12px;">
                                                <!-- Master Information -->
                                                <div class="meta-info-box mb-0">
                                                    
                                                    <div class="d-flex" style="display: flex; justify-content: space-between;">
                                                        <div>
                                                            <div style="margin-bottom: 8px;">
                                                                <strong>To,</strong>
                                                            </div>
                                                            <div style="margin-bottom: 4px; font-weight: bold;">
                                                                {{ invoiceData?.supplier?.supplier_name || invoiceData?.supplier?.name || '-' }}
                                                            </div>
                                                            <div style="margin-bottom: 16px;">
                                                                {{ invoiceData?.supplier?.supplier_address || '-' }}
                                                            </div>
                                                            <div style="margin-bottom: 4px;">
                                                                <strong>Subject: </strong>Purchase Invoice for {{ invoiceData?.code }}
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div class="meta-item d-flex align-center">
                                                                <strong class="meta-label">Invoice No:</strong>
                                                                <span class="meta-value pl-2">{{ invoiceData?.code }}</span>
                                                            </div>
                                                            <div class="meta-item d-flex align-center justify-end">
                                                                <strong class="meta-label pl-2"> Date:</strong>
                                                                <span class="meta-value pl-2">{{ formatDateTime(invoiceData?.invoice_date) }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Purchase Invoice Details Table -->
                                                <div class="table-container mb-6 mt-0">
                                                    <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center" style="width: 40px; border: 1px solid #000; padding: 2px; font-size: 12px;">SL</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Name</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Code</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Unit</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Quantity</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Price</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Amount</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr v-for="(detail, index) in DetailsData" :key="detail.id">
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ index + 1 }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.name }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.code }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.unit?.name || '-' }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.qty }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ formatNumber(detail?.rate) }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ formatNumber(detail?.qty * detail?.rate) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Subtotal</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.sub_total) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Discount</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.discount_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Tax ({{ invoiceData?.tax_type === "1" ? "Included" : "Excluded" }})</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.tax_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Vat ({{ invoiceData?.vat_type === "1" ? "Included" : "Excluded" }})</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.vat_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Grand Total</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(grandTotal) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Paid</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.paid ?? 0) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Due</td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">{{ formatNumber(invoiceData?.due ?? grandTotal) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- Grand Total in Words -->
                                                <div class="amount-in-words-section mb-4" v-if="grandTotal" style="font-size: 12px;">
                                                    <div class="font-weight-bold">
                                                        Amount in Words: <span style="font-weight: normal; text-transform: capitalize;">{{ getGrandTotalInWords() }}</span>
                                                    </div>
                                                </div>

                                                <!-- Prepared By Info -->
                                                <div class="d-flex mb-4 page-break" style="justify-content: space-between; font-size: 12px;">
                                                    <div class="prepared-section" style="width: 50%;">
                                                        <div class="font-weight-bold mb-1">Prepared By:</div>
                                                        <div>{{ (invoiceData?.created_by || invoiceData?.createdBy)?.full_name || '-' }}</div>
                                                        <div v-if="(invoiceData?.created_by || invoiceData?.createdBy)?.branch?.company?.name">
                                                            {{ (invoiceData?.created_by || invoiceData?.createdBy)?.branch?.company?.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td colspan="100%" style="border:none">
                                            <div style="width:100%;height: 100px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div class="invoice-footer">
                            <img v-if="invoiceData?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${invoiceData?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;">
                        </div>
                    </div>

                </v-sheet>
            </v-col>
        </v-row>

        <!-- Print Button -->
        <v-row justify="end" class="d-print-none mt-4">
            <v-col cols="12" justify="center" style="display:flex; justify-content: center;">
                <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
                    Print without pad
                </v-btn>
                <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
                    Print with pad
                </v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
    name: "viewPurchaseInvoice",

    data: () => ({
        mainId: null,
        invoiceData: null,
        DetailsData: null,
        invoiceHeader: true,
        pagePadding: 0,
    }),

    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
        grandTotal() {
            return this.invoiceData?.total ?? this.invoiceData?.grand_total ?? 0;
        },
    },

    methods: {
        formatDateView,
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDateView(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            if (num == null || num === "") return "";
            return Number(num).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        getGrandTotalInWords() {
            if (!this.grandTotal) {
                return "Zero Taka Only";
            }
            try {
                return convertNumberToWords(this.grandTotal);
            } catch (error) {
                console.error('Error converting number to words:', error);
                return "Zero Taka Only";
            }
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `purchase-invoice-${this.invoiceData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { 
                    scale: 2, 
                    useCORS: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                    letterRendering: true
                },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        print(isPad) {
            if (isPad === 1) {
                this.invoiceHeader = true;
                this.pagePadding = 0;
            } else if (isPad === 0) {
                this.invoiceHeader = false;
                this.pagePadding = 100;
            }

            setTimeout(() => {
                const printContent = document.getElementById("printable-area").innerHTML;
                const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
            
                printWindow.document.write(`
                  <!DOCTYPE html>
                  <html>
                  <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Purchase Invoice</title>
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                      box-sizing: border-box;
                    }
            
                    @page {
                      size: A4;
                      margin: ${this.pagePadding}px 0;
                    }
            
                    html, body {
                      margin: 0;
                      padding: 0; 
                      width: 100%;
                      height: auto;
                    }
            
                    body { 
                      font-family: sans-serif; 
                      background:#fff; 
                      color:#000; 
                      -webkit-print-color-adjust: exact; 
                      print-color-adjust: exact;
                      margin: 0;
                      padding: 0;
                    }
            
                    .report-paper { 
                      width: 100%; 
                      padding: 0 !important;
                      background: #fff;
                      margin: 0;
                    }

                    .page-break {
                        page-break-inside: avoid;
                    }
                    .font-weight-bold {
                        font-weight: bold;
                    }
            
                    .invoice-container {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                    }
            
                    .invoice-content {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: visible;
                    }
            
                    header img {
                      width: 100%;
                      display: block;
                      margin: 0;
                      padding: 0;
                    }
            
                    table {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                    }

                    .details-table {
                      padding: 0px 32px;
                    }
            
                    footer {
                      position: fixed;
                      bottom: 0;
                      left: 0;
                      right: 0;
                      width: 100%;
                      z-index: 10;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    footer img {
                      width: 100%;
                      display: block;
                      margin: 0;
                      padding: 0;
                    }
            
                    .header-section { 
                      display: flex; 
                      justify-content: space-between; 
                      align-items: flex-start; 
                      border-bottom: 2px solid #eee; 
                      padding-bottom: 10px; 
                      margin-bottom: 16px; 
                    }
            
                    .company-name { 
                      font-size: 12px; 
                      font-weight: bold; 
                      text-transform: uppercase; 
                      margin: 0 0 4px 0; 
                    }
            
                    .company-text { 
                      font-size: 12px; 
                      margin: 2px 0; 
                      display: flex; 
                      align-items: center; 
                    }
            
                    .logo-container img { 
                      max-height: 70px; 
                      max-width: 150px; 
                    }
            
                    .report-title { 
                      font-size: 16px; 
                      text-align: center; 
                      padding: 5px 0; 
                    }
            
                    .watermark {
                      position: fixed;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      z-index: 0;
                      pointer-events: none;
                    }
            
                    table { 
                      width: 100% !important; 
                      border-collapse: collapse; 
                      font-size: 12px; 
                      margin: 8px 0;
                      background: white;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    th, td { 
                      border: none; 
                      padding: 0; 
                      vertical-align: middle; 
                    }
            
                    th { 
                      background: #e0e0e0; 
                      text-align: center; 
                      font-weight: bold;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-left { text-align: left; }
                    
                    /* Allow table to break across pages */
                    .dep-table {
                      page-break-inside: auto;
                      width: 100%;
                    }
                    
                    .dep-table tbody tr {
                      page-break-inside: avoid;
                      page-break-after: auto;
                    }
                    
                    .dep-table thead {
                      display: table-header-group;
                      page-break-after: avoid;
                    }

                    .mt-4 { 
                      margin-top: 0px !important;
                      margin-left: -10px !important;
                      margin-right: -10px !important;
                    }
                    .mt-5 { 
                      margin-top: 5px !important;
                      margin-left: 0px !important;
                      margin-right: 0px !important;
                    }
                    .mt-8 { margin-top: 0px !important; }
                    .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
            
                    img { 
                      max-width: 100% !important; 
                      height: auto !important; 
                    }
            
                    .d-flex { display: flex; }
                    .justify-space-between { justify-content: space-between; }
                    .align-start { align-items: flex-start; }
                    .align-center { align-items: center; }
                    .justify-end { justify-content: flex-end; }
                    .v-row { 
                      display: flex !important; 
                      flex-wrap: wrap !important; 
                      margin: 0;
                      width: 100%;
                      padding: 0px 30px;
                      justify-content: space-between;
                    }
            
                    .v-col-6 { 
                      flex: 0 0 50% !important; 
                      max-width: 50% !important; 
                      padding: 0 12px 12px 12px;
                      box-sizing: border-box;
                      margin: 0;
                    }
            
                    .pa-6 { padding: 0 !important; }
            
                    .signature-box {
                      font-size: 12px;
                      border: 1px solid black;
                      border-radius: 5px;
                      padding: 10px;
                    }
            
                    .signature-line {
                      border-bottom: 1px solid #000;
                      margin: 50px 0;
                      height: 30px;
                    }
            
                    .signature-label {
                      text-transform: uppercase;
                      font-weight: bold;
                      font-size: 12px;
                    }
            
                    .invoice-container {
                      display: flex;
                      flex-direction: column;
                    }
            
                    .invoice-content {
                      flex: 1;
                      overflow: visible;
                      margin-top: 0;
                    }
                      
                    .company-info {
                      flex: 1;
                    }
            
                    .invoice-footer {
                      margin-top: auto;
                      position: fixed;
                      left: 0;
                      bottom: 0;
                      width: 100%;
                      z-index: 5;
                    }

                    .amount-in-words-section {
                      page-break-inside: avoid;
                    }

                    .page-content-cell {
                      page-break-inside: auto;
                    }

                    .prepared-section {
                      page-break-inside: avoid;
                    }

                    .system-generated-footer {
                      page-break-inside: avoid;
                    }
            
                    @media print { 
                      body {
                        margin: 0;
                        padding: 0;
                      }
            
                      .report-paper {
                        margin: 0;
                        padding: 0;
                      }
            
                      .watermark {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 0;
                      }
                    }
                  </style>
                  </head>
                  <body>
                    ${printContent}
                  </body>
                  </html>
                `);
            
                printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                  printWindow.print();
                }, 500);
                this.invoiceHeader = true;
                this.pagePadding = 0;
            }, 500);
        },
    },

    mounted() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.DetailsData = null;
        this.$store.dispatch("getPurInvoiceById", id).then((response) => {
            this.invoiceData = response;
            this.DetailsData = response.purInvoiceDetails || response.pur_invoice_details || [];
        }).catch((error) => {
            console.error('Error fetching purchase invoice:', error);
        });
    },
};
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 12px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; }
.report-title { font-size: 16px; text-align: center; margin: 4px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 12px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.invoice-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

.invoice-content {
  width: 100%;
  margin: 0;
  padding: 0;
}

.invoice-footer {
  width: 100%;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 16px;
}

.company-info {
  flex: 1;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logo-container img {
  max-height: 70px;
  max-width: 150px;
}

.page-content {
  display: block;
}

.page-content-cell {
  padding: 0 !important;
  border: none !important;
}

.my-6 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between;
}

.align-start {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.font-weight-bold {
  font-weight: bold;
}

.pl-2 {
  padding-left: 8px;
}

.mr-2 {
  margin-right: 8px;
}

.ml-2 {
  margin-left: 8px;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.mt-0 {
  margin-top: 0;
}

.mt-5 {
  margin-top: 5px;
}

.gap-2 {
  gap: 8px;
}

.details-table {
  padding: 0px 32px;
}

.table-container {
  margin-bottom: 24px;
}

.meta-info-box {
  border: none;
  margin-bottom: 16px;
  font-size: 12px;
}

.meta-item {
  height: auto;
  display: flex;
  align-items: center;
}

.meta-label {
  font-weight: 500;
  color: #333;
  padding-left: 0;
  text-align: left;
}

.meta-value {
  padding-left: 8px;
  color: #555;
}

.amount-in-words-section {
  margin-bottom: 16px;
  color: #555;
  text-align: left;
}

.prepared-section {
  margin-bottom: 16px;
  color: #555;
}

.system-generated-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 10px;
  font-size: 8px;
  color: #666;
  border-top: 1px solid #ddd;
}

.page-break {
  page-break-inside: avoid;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
